import React from "react";
import { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography, styled } from "@mui/material";
import MainBG from "../assets/images/Background/MainBG.jpg";
import profile from "../assets/images/NoImage/profile.jpg";
import "./CssLayout.css";
import { AxiosGet, AxiosPost } from "utilities/Axios";
import { FnBlock_UI } from "components/BlockUI";
import { Breadcrumbs, SwAlert } from "components";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
import { AuthToken } from "config/AxiosConfig";
import { useNavigate } from "react-router-dom";
import { BtnSaveIcon, BtnCancelIcon } from "components/Button";
import { AiFillEdit } from "react-icons/ai";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { TextBoxForm } from "components/Input";
import { RemoveRedEye, VisibilityOff } from "@mui/icons-material";
import { undefinedOrNull } from "utilities/Function";

const ContainerBG = styled("div")({
	background: `url(${MainBG}) no-repeat center center fixed`,
	WebkitBackgroundSize: "cover",
	MozBackgroundSize: "cover",
	OBackgroundSize: "cover",
	backgroundSize: "cover",
	height: "100vh",
	width: "100%",
	position: "fixed",
	overflowY: "auto",
});

type Props = {
	children?: React.ReactNode;
	propLayout?: any;
};

const LayoutFront: React.FC<Props> = ({ children, propLayout }) => {
	const [isMenu, SetisMenu] = useState("/Home");
	const navigate = useNavigate();
	const { BlockUI, UnBlockUI } = FnBlock_UI();
	const LoginControllerAPI = "Login";

	const [IsManu_Admin, SetIsManu_Admin] = useState(false);
	const [IsManu_User, SetIsManu_User] = useState(false);
	const [IsManu_Report, SetIsManu_Report] = useState(false);

	const [nUserID, SetnUserID] = useState(null);
	const [sImageURL, SetsImageURL] = useState(null);
	const [sFullname, SetsFullname] = useState(null);
	const [sEmail, SetsEmail] = useState(null);
	const [nRoleID, SetnRoleID] = useState(null);
	const [sPosition, SetsPosition] = useState(null);
	// const [nManuID, SetnManuID] = useState(1);

	// useEffect(() => { //เปิดเมนูไว้ตอนแรก
	// 	let sidebar = document.querySelector(".sidebar");
	// 	sidebar.classList.toggle("open");
	// 	let closeBtn = document.querySelector("#btn");
	// 	closeBtn.classList.replace("bx-menu", "bx-menu-alt-right");
	// }, [])

	useEffect(() => {
		onGetDataPemission();
	}, []);

	useEffect(() => {
		let sPathName = window.location.pathname;
		SetisMenu(sPathName);
	}, [window.location.pathname]);

	const onGetDataPemission = () => {
		BlockUI();
		AxiosGet(`${LoginControllerAPI}/onGetDataPemission`, {}, (result) => {
			SetIsManu_Admin(result.IsManu_Admin);
			SetIsManu_User(result.IsManu_User);
			SetIsManu_Report(result.IsManu_Report);
			SetsFullname(result.sFullname);
			SetnRoleID(result.nRoleID);
			SetsEmail(result.sEmail);
			SetsPosition(result.sPosition);
			SetsImageURL(result.sImageURL);
			SetnUserID(result.nUserID);
			UnBlockUI();
		});
	};

	const onImageError = (e) => {
		e.target.src = profile;
	}

	//#region Change Password
	const [open, setOpen] = React.useState(false);
	const [IsTypePass, SetIsTypePass] = useState(true);
	const [IsTypePassOld, SetIsTypePassOld] = useState(true);

	const handleClickOpen = () => { setOpen(true); };
	const handleClose = () => { setOpen(false); };
	useEffect(() => { if (open) handleClickOpen(); }, [open]);

	//#region Form YUP
	const objSchema = yup.object().shape({
		sPassword: yupFormSchemas.string("รหัสผ่านใหม่", { required: true, max: 25, matches: /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]])(?=.{8,}))/, labelmatches: (`รหัสผ่านไม่ผ่านเงื่อนไขที่กำหนด เช่น Teat@1234`) }),
		sConfirmPassword: yupFormSchemas.string("ยืมยัน รหัสผ่านเก่า", { required: true, max: 25, matches: /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]])(?=.{8,}))/, labelmatches: (`รหัสผ่านไม่ผ่านเงื่อนไขที่กำหนด เช่น Teat@1234`) }),
	});
	const [initialValues] = useState(() => {
		return ({
			sPassword: null,
			sConfirmPassword: null,
		});
	});
	const form = useForm({
		resolver: yupResolver(objSchema),
		mode: 'all',
		shouldFocusError: true,
		shouldUnregister: false,
		defaultValues: initialValues as any,
	});
	//#endregion

	const onSaveDataChange = () => {
		let ObjForm = form.getValues();
		let ObjData = {
			sSecureCode: undefinedOrNull(ObjForm.sPassword, "string"),
			sConfirmSecureCode: undefinedOrNull(ObjForm.sConfirmPassword, "string"),
		};
		SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmChange, () => {
			BlockUI();
			AxiosPost(`${LoginControllerAPI}/onSaveDataChangePassword`, ObjData, (res) => {
				SwAlert.Success(AlertTitle.Success, AlertMsg.SaveComplete);
				handleClose();
			}, null, null, null, () => { UnBlockUI(); });
		});
	};
	//#endregion

	return (
		<ContainerBG>
			<div style={{ minHeight: "85vh", }} >
				<div className="sidebar">
					<div className="logo-details">
						<div className="logo_name">Recruitment</div>
						<i className="bx bx-menu"
							id="btn"
							onClick={(e) => {
								let sidebar = document.querySelector(".sidebar");
								sidebar.classList.toggle("open");

								let closeBtn = document.querySelector("#btn");
								if (sidebar.classList.contains("open")) {
									closeBtn.classList.replace("bx-menu", "bx-menu-alt-right");
								} else {
									closeBtn.classList.replace("bx-menu-alt-right", "bx-menu");
								}
							}}
						/>
					</div>
					<ul className="nav-list">
						<li>
							<a href={process.env.REACT_APP_URL + "Home"} >{/* onClick={(e)=> {SetnManuID(1);}} */}
								<i className='bx bx-home'></i>
								<span className="links_name">หน้าแรก</span>
							</a>
							<span className="tooltip">หน้าแรก</span>
						</li>
						{IsManu_Admin &&
							<li>
								<a href={process.env.REACT_APP_URL + "AdminUser"} >{/* onClick={(e)=> {SetnManuID(2);}} */}
									<i className='bx bx-user-circle'></i>
									<span className="links_name">ข้อมูลผู้ใช้งาน</span>
								</a>
								<span className="tooltip">ข้อมูลผู้ใช้งาน</span>
							</li>
						}
						{IsManu_User &&
							<li>
								<a href={process.env.REACT_APP_URL + "UserRecruitment"} >{/* onClick={(e)=> {SetnManuID(3);}} */}
									{/* <i className="bx bx-folder bx-tada"></i> */}
									<i className='bx bx-book-reader'></i>
									<span className="links_name">ข้อมูลผู้สมัคร</span>
								</a>
								<span className="tooltip">ข้อมูลผู้สมัคร</span>
							</li>
						}
						{IsManu_Report &&
							<li>
								<a href={process.env.REACT_APP_URL + "Report"} >{/* onClick={(e)=> {SetnManuID(4);}} */}
									<i className="bx bx-pie-chart-alt-2"></i>
									<span className="links_name">รายงาน</span>
								</a>
								<span className="tooltip">รายงาน</span>
							</li>
						}
						<li>
							<a href={process.env.REACT_APP_URL + "RegisterRecruitment"} >{/* onClick={(e)=> {SetnManuID(4);}} */}
								<i className='bx bx-calendar-edit'></i>
								<span className="links_name">แบบฟอร์มการสมัครออนไลน์</span>
							</a>
							<span className="tooltip">แบบฟอร์มการสมัครออนไลน์</span>
						</li>
						<li className="profile">
							<div className="profile-details">
								<img
									alt="profileImg"
									src={sImageURL != null ? process.env.REACT_APP_API_URL + sImageURL : profile}
									onError={onImageError}
									title={sFullname + " (" + sPosition + ")"}
								/>
								<div className="name_job">
									<div className="name">{sFullname}</div>
									<div className="job">{"Role: " + sPosition}</div>
								</div>
							</div>
							<i className="bx bx-git-compare"
								id="pass_word"
								title="เปลี่ยนรหัสผ่าน"
								onClick={(e) => { setOpen(true); }}
							/>
							<i className="bx bx-log-out"
								id="log_out"
								title="ออกจากระบบ"
								onClick={(e) => {
									SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmLogout, () => {
										AuthToken.set("");
										navigate("/");
									});
								}}
							/>
						</li>
					</ul>
				</div>
				<section className="home-section">
					{/* <div className="text">Home</div> */}
					<div className={"Divbreadcrumb"}>
						<Grid item xs={12} sm={12} md={12}>
							<Grid item className='Divbreadcrumb_' >
								<Grid item xs={12} sm={12} md={12} container spacing={1}>
									{/* <Grid item>
									{window.location.pathname === "/Home" ?
										<i className='bx bx-home' style={{fontSize: 'larger',}}></i>
										: window.location.pathname === "/AdminUser" ? 
											<i className='bx bx-user-circle' style={{fontSize: 'larger',}}></i>
											: window.location.pathname === "/UserRecruitment" ?
												<i className='bx bx-book-reader' style={{fontSize: 'larger',}}></i>
											: window.location.pathname === "/Report" ?
													<i className='bx bx-pie-chart-alt-2' style={{fontSize: 'larger',}}></i>
											: <></>
									}
								</Grid> */}
									<Grid item>
										{window.location.pathname === "/Home" ?
											<Typography variant="h6" display="block" color={"#ffffff"}>หน้าแรก</Typography>
											: window.location.pathname.includes("/AdminUser") ?
												<Typography variant="h6" display="block" color={"#ffffff"}>ข้อมูลผู้ใช้งาน</Typography>
												: window.location.pathname.includes("/UserRecruitment") ?
													<Typography variant="h6" display="block" color={"#ffffff"}>ข้อมูลผู้สมัคร</Typography>
													: window.location.pathname.includes("/Report") ?
														<Typography variant="h6" display="block" color={"#ffffff"}>รายงาน</Typography>
														: <></>
										}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</div>
					<div className={"div-child"}>
						{children}
					</div>
				</section>
			</div>

			<Dialog
				maxWidth={"xs"}
				fullWidth={true}
				open={open}
				onClose={handleClose}
				sx={{ borderRadius: "23px", zIndex: '999', }}
			>
				<DialogTitle style={{
					borderBottom: "1px solid #FD8D14"
				}}><AiFillEdit /> เปลี่ยนรหัสผ่าน</DialogTitle>
				<FormProvider {...form}>
					<DialogContent>
						<Grid container direction="row" xs={12} md={12} spacing={2} marginTop={1} >
							<Grid item xs={12} md={12}>
								<TextBoxForm
									name="sPassword"
									label={"รหัสผ่านใหม่"}
									type={!IsTypePass ? "text" : "password"}
									maxLength={20}
									required={true}
									endAdornment={
										<>
											<IconButton
												style={{ padding: '0px' }}
												onClick={(() => { SetIsTypePass(!IsTypePass) })}
											>
												{IsTypePass ? <VisibilityOff /> : <RemoveRedEye />}
											</IconButton>
										</>
									}
									disabled={false}
									isshowTextCont={false}
								/>
							</Grid>
							<Grid item xs={12} md={12}>
								<TextBoxForm
									name="sConfirmPassword"
									label={"ยืมยัน รหัสผ่านเก่า"}
									type={!IsTypePassOld ? "text" : "password"}
									maxLength={20}
									required={true}
									endAdornment={
										<>
											<IconButton
												style={{ padding: '0px' }}
												onClick={(() => { SetIsTypePassOld(!IsTypePassOld) })}
											>
												{IsTypePassOld ? <VisibilityOff /> : <RemoveRedEye />}
											</IconButton>
										</>
									}
									disabled={false}
									isshowTextCont={false}
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Grid marginTop={1} md={12} container direction="row" alignItems="center" justifyContent="center" sx={{}}>
							<BtnCancelIcon style={{ width: "130px", marginLeft: "10px" }} onClick={() => { form.reset(); handleClose(); }} />
							<BtnSaveIcon style={{ width: "130px", marginLeft: "10px" }} onClick={form.handleSubmit(() => { onSaveDataChange(); })} />
						</Grid>
					</DialogActions>
				</FormProvider>
			</Dialog>

		</ContainerBG>
	);
};
export default LayoutFront;
